import { render, staticRenderFns } from "./OrderBasket.vue?vue&type=template&id=bb714272&"
import script from "./OrderBasket.vue?vue&type=script&lang=js&"
export * from "./OrderBasket.vue?vue&type=script&lang=js&"
import style0 from "./OrderBasket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports